import colorInterpolate from "color-interpolate"

const COLOR_PALETTE = [
    "#E33059", "#F75839", "#F7943D", "#e3b022",
    "#b3b020", "#95C631", "#56A754", "#11826D",
    "#3160A3", "#5B37CC", "#A347BF", "#EA57B2",
    "#E33059"
]; // insert the first color at the end to make position (11/12) be the last color

export function getColorFromRainbowPalette (position) { // position range: [0, 1)
    const map = colorInterpolate(COLOR_PALETTE);
    return map(position);
}

